import { getTimeZone, emitEventToPiniaStore } from '@/utils/common'


export default {
  state: {
    isMobile: false,
    isTablet: false,
    hideHeaderNavigation: true,
    errorCode: '',
    showLoader: true,
    registrationId: '',
    isFileUploading: false,
    timezone: getTimeZone()
  },
  getters: {
    getIsMobile (state) {
      return state.isMobile
    },
    getIsTablet (state) {
      return state.isTablet
    },
    getHideHeaderNavigation (state) {
      return state.hideHeaderNavigation
    },
    getErrorCode (state) {
      return state.errorCode
    },
    getShowLoader (state) {
      return state.showLoader
    },
    getIsFileUploading (state) {
      return state.isFileUploading
    },
    getTimeZone (state) {
      return state.timezone
    }
  },
  mutations: {
    setRegistrationId (state, value) {
      state.registrationId = value
    },
    setMobileDeviceStatus (state, status) {
      state.isMobile = status
    },
    setTabletDeviceStatus (state, status) {
      state.isTablet = status
    },
    setHideHeaderNavigation (state, status) {
      state.hideHeaderNavigation = status
    },
    setShowLoader (state, value) {
      emitEventToPiniaStore('VUEX_APP_LOADER', value)
      state.showLoader = value
    },
    setAppLoaderFromPinia (state, value) {
      state.showLoader = value
    },
    setErrorCode (state, value) {
      emitEventToPiniaStore('VUEX_SET_ERROR_CODE', value)
      state.errorCode = value
    },
    setFileUploading (state, value) {
      state.isFileUploading = value
    },
    setErrorCodeFromPinia (state, value) {
      state.errorCode = value
    }
  },
  namespace: false
}
